module.exports = __webpack_public_path__ + "img/page9img5.cd5016b2.png";